import { useEffect, useState } from "react";
import PortalHome from "../../app/page";
import AdminPage from "../../app/admin/page";
import MobilePortal from "../../app/mobile/page";
import { NgStatus } from "./components/NgStatus";
import { currentUser, onAuthChange } from "./lib/pocketbase";

export function App() {
  const [authenticatedUser, setAuthenticatedUser] = useState(currentUser());
  const isAdmin = window.location.pathname.startsWith("/admin");
  const isMobile = window.location.pathname.startsWith("/mobile");

  useEffect(() => onAuthChange(setAuthenticatedUser), []);

  return <><NgStatus />{isAdmin ? <AdminPage /> : isMobile ? <MobilePortal /> : <PortalHome authenticatedEmail={String(authenticatedUser?.email || "")} />}</>;
}
